import { create } from 'zustand';

/** Lage des virtuellen Joysticks in Host-Pixeln, solange ein Finger ihn haelt. */
export interface StickZustand {
  basisX: number;
  basisY: number;
  knopfX: number;
  knopfY: number;
}

interface TouchSteuerungState {
  stick: StickZustand | null;
  setStick: (stick: StickZustand | null) => void;
}

/**
 * Bruecke zwischen Touch-Steuerung und ihrer Anzeige: der Controller meldet,
 * die Overlay-Komponente zeichnet. Ereignisgetrieben, nicht je Bild.
 */
export const useTouchSteuerungStore = create<TouchSteuerungState>((set) => ({
  stick: null,
  setStick: (stick) => set({ stick }),
}));
